
document.addEventListener('DOMContentLoaded', () => {
    const hash = window.location.hash; // URLのハッシュ部分を取得
    if (hash) {
        const targetElement = document.querySelector(hash); // ハッシュに対応する要素を取得
        if (targetElement) {
            // デフォルトのスクロールを防ぐ
            window.scrollTo(0, 0);

            // デバウンス関数
            const debounce = (func, delay) => {
                let timer;
                return (...args) => {
                    clearTimeout(timer);
                    timer = setTimeout(() => func(...args), delay);
                };
            };

            // スクロール実行関数
            const smoothScroll = debounce(() => {
                const boundingRect = targetElement.getBoundingClientRect();
                const isInViewport =
                    boundingRect.top >= 0 &&
                    boundingRect.bottom <= window.innerHeight;

                if (!isInViewport) {
                    targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
                } else {
                    observer.disconnect(); // 正しい位置に到達したら監視を停止
                }
            }, 500); // 100msの遅延でデバウンス

            // MutationObserverでDOM変化を監視
            const observer = new MutationObserver(() => smoothScroll());

            observer.observe(document.body, {
                childList: true,
                subtree: true,
            });

            // ページが完全にロードされたら一度スクロール
            window.addEventListener('load', () => {
                targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
            });
        }
    }
});
